import React, { useState, useEffect } from 'react';
import { updateConsent, CONSENT_STORAGE_KEY } from '../lib/analytics';

/**
 * Bandeau de consentement — palette Perrinos (crème / encre / bleu
 * électrique, boutons du design system). L'ancienne version utilisait
 * slate-900 + indigo-600, étrangère à la charte.
 */
export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    } else {
      updateConsent(consent === 'granted');
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'granted');
    updateConsent(true);
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, 'denied');
    updateConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[color:var(--border-strong)] p-4 md:p-5 flex flex-col sm:flex-row items-center justify-between gap-4"
      style={{ boxShadow: '0 -10px 34px -24px rgba(15, 30, 60, 0.55)' }}
      data-testid="consent-banner"
    >
      <p className="text-sm text-ink-2 max-w-2xl leading-relaxed">
        Nous utilisons PostHog et Google Analytics pour mesurer l'audience et
        améliorer votre expérience sur perrinos.tech. Vous pouvez refuser les
        cookies non essentiels sans altérer le service.
      </p>
      <div className="flex gap-3 shrink-0">
        <button
          onClick={handleReject}
          className="btn-ghost text-sm"
          data-testid="consent-reject"
        >
          Refuser l'essentiel
        </button>
        <button
          onClick={handleAccept}
          className="btn-gold text-sm"
          data-testid="consent-accept"
        >
          Tout accepter
        </button>
      </div>
    </div>
  );
}
